import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SortOrder} from './sort-order';

@Component({
    selector: 'zah-sort-button',
    templateUrl: './sort-button.component.html',
    styleUrls: ['./sort-button.component.scss'],
    standalone: false
})
export class SortButtonComponent {

  @Input()
  sortOrder: SortOrder = SortOrder.ASCENDING;
  @Input()
  disabled = false;
  @Output()
  sortOrderChange: EventEmitter<SortOrder> = new EventEmitter<SortOrder>();

  getIcon(): string {
    return this.isAscending() ? 'arrow_downward' : 'arrow_upward';
  }

  onClick(): void {
    this.toggleSortOrder();
    this.sortOrderChange.emit(this.sortOrder);
  }

  private toggleSortOrder(): void {
    this.sortOrder = this.isAscending() ? SortOrder.DESCENDING : SortOrder.ASCENDING;
  }

  private isAscending(): boolean {
    return this.sortOrder === SortOrder.ASCENDING;
  }
}
